import { createSlice } from "@reduxjs/toolkit"

type CommonState = {
  errorObject: {
    message: string
    serverMessage: string
    status: number
    code: number
    data: any
    url: string
  }
  shop: {
    itemDeleted: boolean
    itemUpdated: boolean
    itemBought: boolean
  }
}

export const commonSlice = createSlice({
  name: "common",
  initialState: {
    errorObject: {
      message: "",
      serverMessage: "",
      status: 0,
      code: 0,
      data: null,
      url: ""
    },
    shop: {
      itemDeleted: false,
      itemUpdated: false,
      itemBought: false
    }
  } as CommonState,
  reducers: {
    setErrorMessage(state, { payload }) {
      const { status, code, message, data, url, serverMessage } = payload
      state.errorObject = {
        message,
        serverMessage: serverMessage ?? "",
        status,
        code,
        data,
        url: url ?? ""
      }
    },
    setItemDeleted(state, { payload }) {
      state.shop.itemDeleted = payload
    },
    setItemUpdated(state, { payload }) {
      state.shop.itemUpdated = payload
    },
    setItemBought(state, { payload }) {
      state.shop.itemBought = payload
    }
  }
})

export const {
  setErrorMessage,
  setItemDeleted,
  setItemUpdated,
  setItemBought
} = commonSlice.actions
